var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreateBroadcast = function SvgCreateBroadcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_broadcast_svg2__b",
    x1: 136.53,
    x2: 41.68,
    y1: 48.16,
    y2: 165.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_broadcast_svg2__a",
    x1: 185.27,
    x2: 78.09,
    y1: 27.3,
    y2: 203.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#create_broadcast_svg2__a",
    id: "create_broadcast_svg2__c",
    x1: 128.85,
    x2: 21.67,
    y1: -6.97,
    y2: 169.52
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#create_broadcast_svg2__a",
    id: "create_broadcast_svg2__d",
    x1: 153.65,
    x2: 46.47,
    y1: 8.09,
    y2: 184.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#create_broadcast_svg2__a",
    id: "create_broadcast_svg2__e",
    x1: 152.24,
    x2: 45.06,
    y1: 7.24,
    y2: 183.72
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#create_broadcast_svg2__a",
    id: "create_broadcast_svg2__f",
    x1: 152.28,
    x2: 45.1,
    y1: 7.26,
    y2: 183.75
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 93.33,
    r: 76.04,
    style: {
      fill: "url(#create_broadcast_svg2__b)",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "09-Broadcast"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m138.8 175.47 3.82 10 3.82 10c.2.52.26 1.06.2 1.6s-.25 1.05-.57 1.5c-.31.45-.72.81-1.19 1.05s-1 .38-1.54.38H56.66c-.55 0-1.07-.14-1.54-.38s-.88-.6-1.19-1.05a3.32 3.32 0 0 1-.37-3.1l18.88-49.4 18.88-49.4a13.5 13.5 0 0 1-3.42-4.49c-.8-1.71-1.23-3.58-1.25-5.51 0-3.68 1.49-7.02 3.91-9.43 2.41-2.41 5.75-3.91 9.43-3.91s7.02 1.49 9.43 3.91a13.3 13.3 0 0 1 3.91 9.43 13.3 13.3 0 0 1-4.67 10l12.52 32.68 12.52 32.68a3.33 3.33 0 0 1-1.9 4.3 3.1 3.1 0 0 1-1.2.24c-.69 0-1.34-.21-1.88-.59s-.97-.9-1.22-1.55l-1.82-4.72-1.82-4.72-8.97 6.08-8.97 6.08 15.25 10.35 15.25 10.35-1.92-5-1.92-5c-.04-.07-.07-.15-.1-.23s-.06-.15-.08-.23a3.335 3.335 0 0 1 2.22-4.16 3.335 3.335 0 0 1 4.16 2.22Zm-6.34 17.86-16.23-11.02L100 171.29l-16.23 11.02-16.23 11.02h64.93ZM76.13 155.1l-6.28 16.43-6.28 16.43 15.25-10.35 15.25-10.35-8.97-6.08zm23.87 8.23 10-6.77 10-6.77-10-8.6-10-8.6-10 8.6-10 8.6 10 6.77zm-17.67-24.3 6.28-5.42 6.28-5.42-3.18-2.72-3.18-2.72-3.1 8.13-3.1 8.13Zm22.77-10.83 6.3 5.42 6.3 5.42-3.12-8.13-3.12-8.13-3.18 2.72-3.18 2.72ZM100 80c-1.84 0-3.51.75-4.71 1.95-1.21 1.21-1.95 2.87-1.95 4.71s.75 3.51 1.95 4.71 2.87 1.95 4.71 1.95 3.51-.75 4.71-1.95c1.21-1.21 1.95-2.87 1.95-4.71s-.75-3.51-1.95-4.71A6.63 6.63 0 0 0 100 80m0 20c-.45 0-.91-.02-1.36-.07s-.9-.11-1.34-.2l-3.12 8.15-3.12 8.15 4.47 3.83 4.47 3.83 4.47-3.83 4.47-3.83-3.12-8.15-3.12-8.15c-.44.09-.89.15-1.34.2s-.9.07-1.36.07",
    style: {
      fill: "url(#create_broadcast_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7 69.8c.75.53 1.22 1.31 1.37 2.14s-.02 1.73-.54 2.49a33.3 33.3 0 0 0-5.82 17.3 33.3 33.3 0 0 0 4.16 17.77c.45.8.53 1.71.3 2.53a3.3 3.3 0 0 1-1.57 2c-.25.14-.51.25-.79.32s-.56.11-.84.11c-.6 0-1.18-.16-1.68-.46-.5-.29-.93-.72-1.22-1.24a40 40 0 0 1-5.01-21.35 40 40 0 0 1 7.01-20.78c.53-.75 1.31-1.22 2.14-1.37s1.73.02 2.49.54",
    style: {
      fill: "url(#create_broadcast_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4 114.03c-.8-.45-1.34-1.18-1.57-2s-.15-1.73.3-2.53a33.36 33.36 0 0 0 4.14-17.76 33.27 33.27 0 0 0-5.82-17.28c-5.21-7.59-13.01-12.34-21.4-13.89s-17.37.09-24.95 5.3c-.73.45-1.56.59-2.35.45s-1.52-.56-2.04-1.24c-.56-.73-.78-1.61-.67-2.46s.54-1.65 1.26-2.22a40.03 40.03 0 0 1 20.74-6.99c7.29-.35 14.68 1.29 21.31 4.97 9.66 5.36 16.23 14.12 19.05 23.96s1.89 20.76-3.47 30.42c-.29.52-.72.95-1.22 1.24s-1.08.46-1.68.46a3.34 3.34 0 0 1-1.63-.43",
    style: {
      fill: "url(#create_broadcast_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 143.1c-.47 0-.94-.09-1.36-.28s-.81-.46-1.13-.81a3.338 3.338 0 0 1 .23-4.71c6.17-5.64 11-12.46 14.28-19.95s5.02-15.66 4.99-24.02c0-16.56-6.72-31.55-17.57-42.41-10.85-10.85-25.85-17.57-42.41-17.57-16.57 0-31.57 6.71-42.43 17.56S40.02 76.76 40.01 93.33c-.03 8.36 1.7 16.53 4.99 24.02a59.3 59.3 0 0 0 14.28 19.95c.67.62 1.03 1.46 1.07 2.31s-.25 1.71-.87 2.39l-.01.01-.01.01c-.63.67-1.47 1.03-2.32 1.06s-1.72-.26-2.39-.89c-.64-.59-1.26-1.19-1.87-1.8s-1.21-1.24-1.8-1.87C38.58 125 32.74 107.7 33.41 90.65s7.83-33.84 21.35-46.34 30.82-18.34 47.87-17.67 33.84 7.83 46.34 21.35 18.34 30.82 17.67 47.87-7.83 33.84-21.35 46.34q-.465.435-1.05.66c-.585.225-.8.23-1.22.24Z",
    style: {
      fill: "url(#create_broadcast_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 0c14.9 0 29.36 3.56 42.29 10.13a93.3 93.3 0 0 1 33.11 28.19c15.19 20.82 20.5 45.83 16.81 69.43s-16.38 45.79-37.2 60.98c-.29.21-.6.37-.93.47s-.68.16-1.03.16a3.314 3.314 0 0 1-2.71-1.38 3.33 3.33 0 0 1 .75-4.65c3.63-2.65 7.05-5.57 10.22-8.74s6.09-6.58 8.74-10.22c14.1-19.34 19.03-42.56 15.6-64.47s-15.22-42.52-34.56-56.62-42.56-19.03-64.47-15.6S44.1 22.9 30 42.24 10.97 84.8 14.4 106.71s15.22 42.52 34.56 56.62c.75.54 1.2 1.34 1.33 2.18s-.06 1.74-.6 2.49-1.34 1.2-2.18 1.33-1.74-.06-2.49-.6a93.2 93.2 0 0 1-28.19-33.11A93.3 93.3 0 0 1 6.7 93.33c0-25.77 10.44-49.11 27.33-66C50.89 10.45 74.22 0 100 0",
    style: {
      fill: "url(#create_broadcast_svg2__f)"
    }
  })));
};
export default SvgCreateBroadcast;